module.exports = __webpack_public_path__ + "static/media/facebook.bee9c1ec.svg";